// src/components/SuggestionsSidebar.js
import React from "react";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Stack from "@mui/material/Stack";

const SuggestionsSidebar = ({ analysis, accepted }) => {
  return (
    <Stack spacing={3} sx={{ width: "100%" }}>
      <Typography variant="h6">Explanations</Typography>
      <Paper sx={{ width: "100%", p: 2, height: "fit-content" }} elevation={3}>
        <List dense>
          {analysis.suggestions.map(
            (sug, idx) =>
              accepted[idx] !== false && (
                <ListItem
                  key={idx}
                  sx={{
                    pb: 1.5,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    borderBottom: "1px solid #eee",
                    "&:last-child": {
                      borderBottom: "none",
                    },
                  }}
                >
                  <Typography
                    component="div"
                    sx={{
                      fontWeight: 600,
                      color: "primary.main",
                      mb: 0.5,
                    }}
                  >
                    {sug.section}
                  </Typography>
                  <Typography component="div" variant="body2" sx={{ pl: 1 }}>
                    {sug.suggestion}
                  </Typography>
                </ListItem>
              )
          )}
        </List>
        <Typography sx={{ mt: 3 }}>
          <b>ATS Match Score Before:</b> {analysis.score_before}%
        </Typography>
        <Typography sx={{ mt: 3 }}>
          <b>ATS Match Score After:</b> {analysis.score}%
        </Typography>
      </Paper>
    </Stack>
  );
};

export default SuggestionsSidebar;
